import { useMutation } from '@tanstack/react-query';

import { uploadFileToStorage } from '@/api/mutations/file/uploadFileToStorage';
import { UploadFileInput } from '@/gql/graphql';

const useCreateUpload = () => {
  return useMutation({
    mutationFn: (variables: {
      file: File;
      linkedEntities?: UploadFileInput['linkedEntities'];
    }) =>
      uploadFileToStorage(
        variables.file,
        variables.file.name,
        variables.linkedEntities || []
      ),
  });
};

export default useCreateUpload;
